import { gql } from '@urql/core'

export const UPDATE_DISPLAY_NAME_MUTATION = gql`
  mutation UpdateDisplayName($displayName: String!) {
    updateDisplayName(displayName: $displayName) {
      displayName
    }
  }
`
